import Component from '../../shared/component';

export default class ClickElement extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.url = this.$element.data('url');

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.ClickElement', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.ClickElement', this.handleClick);
  }

  handleClick() {
    window.Turbolinks.visit(this.url);
  }
}
